var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-input-group',{attrs:{"size":"md"}},[_c('b-form-input',{attrs:{"id":"filter-input","type":"search","placeholder":"Buscar"},on:{"update":_vm.onSearch},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_c('b-input-group-append',[_c('b-input-group-text',[_c('b-icon-search')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }